import React from 'react';
import '../styles/WhatsAppSection.css';

function WhatsAppSection() {
  const whatsappLink = 'https://wa.link/vhj9y0';

  return (
    <div className="whatsapp-section">
      <p className="whatsapp-text">¿Tienes una duda antes de asegurar tu cupo? Escribenos por WhatsApp.</p>
      
      <a
        href={whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="whatsapp-button-inline"
        title="Contactanos por WhatsApp"
      >
        <img src="/whatsapp.apng" alt="WhatsApp" className="whatsapp-icon-inline" />
      </a>
    </div>
  );
}

export default WhatsAppSection;
